<template>
  <div class="p-5">
    <data-grid
      v-if="gridDataSource"
      ref="grid"
      stripe
      :data-source="gridDataSource"
      :search-data="gridSearchData"
      :columns="[{ title: 'مدرک' }, { title: 'تصویر' }]"
    >
      <template slot-scope="{ row }">
        <td style="width: 30%">
          {{ row.documentSettingName }}
        </td>
        <td style="width: 60%">
          <div class="w-full flex justify-center">
            <img
              v-if="row.document"
              :src="URLS_CONSTANTS.assets + 'AgentsAttachments/' + row.document"
              style="max-height: 100px"
              class="rounded cursor-pointer"
              :alt="row.documentSettingName"
              @click.prevent="
                showImagePopup(
                  URLS_CONSTANTS.assets + 'AgentsAttachments/' + row.document
                )
              "
            />
          </div>
        </td>
      </template>
    </data-grid>

    <ImagePopup
      v-if="imagePopup"
      :show="imagePopup"
      :image="selectedImage"
      @close="imagePopup = false"
    ></ImagePopup>
  </div>
</template>

<script>
import { URLS_CONSTANTS } from "@/../config";
import DataGrid from "@/components/datagrid/DataGrid";
import ImagePopup from "./ImagePopup.vue";

import { mapActions } from "vuex";
export default {
  props: {
    mode: {
      required: true,
      value: ["legal", "individual"],
    },
  },
  data() {
    return {
      show: false,
      gridDataSource: {
        type: "app",
        service: `/BusinessParties/api/AgentsQuery/${this.$route.params.id}`,
      },
      gridSearchData: {
        keyword: "",
      },
      selectedDocument: {
        id: null,
      },
      imageName: "",
      documents: [],
      URLS_CONSTANTS,
      imagePopup: false,
      selectedImage: "",
    };
  },
  components: {
    DataGrid,
    ImagePopup,
  },
  mounted() {
    if (this.$tabHasPermission("GetDocumentSettingsByPartyType"))
      this.getData();
  },
  methods: {
    ...mapActions({
      getDocumentSettings: "agentsDocumentUpload/getDocumentSettings",
    }),
    getData() {
      const partyType = this.$props.mode === "legal" ? 1 : 0;
      this.getDocumentSettings(partyType).then((res) => {
        let docs = [];
        for (let doc of res) {
          docs.push({
            id: doc.id,
            label: doc.name,
          });
        }
        this.documents = docs;
      });
    },
    showImagePopup(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
  },
};
</script>

<style scoped></style>
